import {
  getTreeNodeChildren,
  getTreeNodeId,
  type TreeNode,
  type TreeNodeList,
} from './treeNode'

export default function getPathForSelectedTreeNode<T extends TreeNode>(
  tree: readonly T[],
  selectedNodeId: string,
  path?: T[]
): T[] | null
export default function getPathForSelectedTreeNode(
  tree: TreeNodeList,
  selectedNodeId: string,
  path?: TreeNode[]
): TreeNode[] | null
export default function getPathForSelectedTreeNode(
  tree: readonly TreeNode[],
  selectedNodeId: string,
  path: TreeNode[] = []
): TreeNode[] | null {
  const stack: { node: TreeNode; path: TreeNode[] }[] = []

  for (const node of tree) {
    stack.push({ node, path: [...path, node] })
  }

  while (stack.length > 0) {
    const { node, path: currentPath } = stack.pop()!

    if (getTreeNodeId(node) === selectedNodeId) {
      return currentPath
    }

    const children = getTreeNodeChildren(node)
    for (let i = children.length - 1; i >= 0; i--) {
      stack.push({ node: children[i], path: [...currentPath, children[i]] })
    }
  }

  return null
}
